import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { putCartPackage } from "../../services/Cart/getCartPackage";

const PackagePriceEditModal = ({
  packagePriceEditModalVisible,
  setPackagePriceEditModalVisible,
  sendDataToPackagePriceEditModal,
  storeId,
  storeCustomerId,
  selectedPackageItemValue,
}) => {
  const [totalPackagePriceValue, setTotalPackagePriceValue] = useState(1);
  const [totalPackageItemCountValue, setTotalPackageItemCountValue] = useState(0);
  const [totalPackageCountGramValue, setTotalPackageCountGramValue] = useState(0);

  useEffect(() => {
    // Check if selectedPackageItemValue is available
    if (selectedPackageItemValue) {
      setTotalPackagePriceValue(selectedPackageItemValue?.offerPrice);
      setTotalPackageItemCountValue(selectedPackageItemValue?.itemCount);
      setTotalPackageCountGramValue(selectedPackageItemValue?.countGram);
    }
  }, [selectedPackageItemValue]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [packagePriceError, setPackagePriceError] = useState("");

   

  const handleTotalPackagePriceSubmit = () => {
    if (totalPackagePriceValue === 0) {
      setErrorText("Entered Value Must Be Greater Then Zero");
    } else {
      setIsSubmitButtonPressed(true);
   
        const value = totalPackagePriceValue;

      const data = {
        id: selectedPackageItemValue.id,
        offerPrice: Number(value),
        itemCount: totalPackageItemCountValue,
        // itemCount: totalPackageCountValue.toFixed(0),
        countGram: totalPackageCountGramValue,
        // packageCount: packageCount,
        packageDTO: {
          id: selectedPackageItemValue.packageDTO.id,
        },
      };

      if (!isNaN(totalPackagePriceValue)) {
        putCartPackage(storeCustomerId, storeId, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              // setTotalPackagePriceValue();
              sendDataToPackagePriceEditModal({
                success: true,
              });
              setPackagePriceEditModalVisible(false);
              setIsSubmitButtonPressed(false);
              setErrorText("");
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      } else {
        setErrorText("Input is not a number Please enter correct number");
      }
    }
  };

  

  const handlePackagePriceChange = (text) => {

    const inputRegex = /^\d*$/;

      if (!inputRegex.test(text)) return;

    if (text === "") {
      // Handle clearing the input field
      setTotalPackagePriceValue("");
      setErrorText("Price cannot be Empty or Zero");
    } else {
      // Allow only valid numeric input including leading zeros and decimals
      const newPackagePrice = text;
      setTotalPackagePriceValue(newPackagePrice);
      const parsedValue = parseInt(newPackagePrice);
      if (!isNaN(parsedValue)) {
        setErrorText("");
      } else {
        // Handle invalid input
        setErrorText("Please Enter Correct Value");
      }
    }
  };

  const handleModalClose = () => {
    setTotalPackagePriceValue();
    setIsSubmitButtonPressed(false);
    sendDataToPackagePriceEditModal({
      success: true,
    });
    setPackagePriceEditModalVisible(!packagePriceEditModalVisible);
    setErrorText("");
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={packagePriceEditModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!packagePriceEditModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div>
              <div>
                <div
                  className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
                  style={{
                    backgroundImage:
                      "radial-gradient(circle at left top, #2B70D7, #1752AA)",
                  }}
                >
                  <img
                    src={"Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif"}
                    style={{
                      width: 50,
                      height: 50,
                    }}
                  />
                  <p className=" text-4xl text-primary-50 font-semibold">
                    Package Price
                  </p>
                  <Button
                    label="x"
                    onClick={(e) => hide(e)}
                    text
                    className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
                  ></Button>
                </div>
                 
                  <div className="my-3 mx-4">
                    <div className="flex flex-row justify-content-between align-items-center">
                      <div>
                        <p className=" text-xl font-semibold">Price : </p>
                      </div>
                      <div className="flex flex-row justify-content-center align-items-center">
                        

                        <div>
                          <InputText
                            value={totalPackagePriceValue}
                            maxLength={50}
                            onChange={(e) =>
                              handlePackagePriceChange(e.target.value)
                            }
                            className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                          ></InputText>

                          {packagePriceError !== "" && (
                            <p>{packagePriceError}</p>
                          )}
                        </div>
                        
                      </div>
                    </div>
                  </div>
                
                {errorText && (
                  <div
                    style={{
                      marginTop: 2,
                      marginLeft: 10,
                      marginBottom: 10,
                      alignSelf: "center",
                      color: "red"
                    }}
                  >
                    <p>{errorText}</p>
                  </div>
                )}
              </div>

            </div>
              <Button
                disabled={isSubmitButtonPressed}
                onClick={handleTotalPackagePriceSubmit}
                className="mt-1 mb-3 mx-4 border-round-xl "
              >
                <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                  SUBMIT
                </p>
              </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default PackagePriceEditModal;
